import type { ChangeEvent } from "react";
import { twMerge } from "tailwind-merge";

interface RadioProps {
  id: string;
  name: string;
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  checked?: boolean;
  styles?: {
    labelClassNames?: string;
    labelTextClassNames?: string;
    radioClassNames?: string;
    radioCheckMarkClassNames?: string;
  };
}

const Radio = ({
  id,
  label,
  name,
  checked,
  onChange,
  value,
  styles,
}: RadioProps) => {
  return (
    <label
      className={twMerge(
        "relative flex cursor-pointer flex-row items-center justify-center py-1",
        styles?.labelClassNames,
      )}
      htmlFor={id}
    >
      <input
        checked={checked}
        className="peer hidden"
        id={id}
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />
      <span
        className={twMerge(
          "absolute left-0 z-10 flex h-6 w-6 items-center justify-center rounded-full bg-white",
          checked ? "border-2 border-green" : "border border-gray",
          styles?.radioClassNames,
        )}
      />
      <span
        className={twMerge(
          "checked: absolute left-1 z-20 h-4 w-4 rounded-full",
          checked ? "bg-green" : "bg-white",
          styles?.radioCheckMarkClassNames,
        )}
      />
      <p
        className={twMerge(
          "ml-8 text-sm font-normal",
          styles?.labelTextClassNames,
        )}
      >
        {label}
      </p>
    </label>
  );
};

export default Radio;
